import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiLinkedin, FiInstagram } from 'react-icons/fi';

const Footer = () => {
  const [showEasterEgg, setShowEasterEgg] = useState(false);

  const handleLogoClick = () => {
    setShowEasterEgg(true);
    setTimeout(() => setShowEasterEgg(false), 2000);
  };

  return (
    <footer className="bg-white border-t border-gray-100 text-midnight-navy relative overflow-hidden">
      {/* Easter Egg Animation */}
      {showEasterEgg && (
        <motion.div
          className="absolute inset-0 pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-aero-blue/20 to-cyan-400/20 animate-pulse" />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <motion.div
              className="w-20 h-20 bg-aero-blue rounded-full"
              animate={{
                scale: [1, 2, 0],
                rotate: [0, 360],
              }}
              transition={{ duration: 2 }}
            />
          </div>
        </motion.div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <motion.div
              className="text-2xl font-bold cursor-pointer"
              onClick={handleLogoClick}
              whileHover={{ scale: 1.05 }}
            >
              <span className="text-aero-blue">Blacksand</span> Aero
            </motion.div>
            <p className="text-shadow-gray text-sm leading-relaxed">
              Your trusted partner for aviation asset management, continuing airworthiness, 
              global relocation, and comprehensive maintenance solutions.
            </p>
            <div className="text-sm text-shadow-gray">
              Founded 2024 • NZ-Based, Globally Active
            </div>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-midnight-navy">Services</h3>
            <div className="space-y-3">
              <Link to="/services" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Aviation Asset Management
              </Link>
              <Link to="/services" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Airworthiness Oversight
              </Link>
              <Link to="/services" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                MRO Services
              </Link>
              <Link to="/services" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Global Relocation
              </Link>
            </div>
          </div>

          {/* Company */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-midnight-navy">Company</h3>
            <div className="space-y-3">
              <Link to="/projects" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Projects
              </Link>
              <Link to="/partners" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Partners
              </Link>
              <Link to="/contact" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Contact
              </Link>
              <a href="#" className="block text-shadow-gray hover:text-aero-blue transition-colors duration-200">
                Careers
              </a>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-midnight-navy">Contact Info</h3>
            <div className="space-y-4">
              <motion.a
                href="tel:+64212213989"
                className="flex items-center space-x-3 text-shadow-gray hover:text-aero-blue transition-colors duration-200"
                whileHover={{ x: 5 }}
              >
                <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                  <FiPhone className="text-aero-blue w-5 h-5" />
                </div>
                <span>+64 21-221-3989</span>
              </motion.a>
              <motion.a
                href="mailto:hello@blacksand.aero"
                className="flex items-center space-x-3 text-shadow-gray hover:text-aero-blue transition-colors duration-200"
                whileHover={{ x: 5 }}
              >
                <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                  <FiMail className="text-aero-blue w-5 h-5" />
                </div>
                <span>hello@blacksand.aero</span>
              </motion.a>
              
              {/* Social Links */}
              <div className="flex space-x-3 pt-4">
                <motion.a
                  href="#"
                  className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-aero-blue hover:bg-aero-blue hover:text-white transition-all duration-200"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <FiLinkedin size={18} />
                </motion.a>
                <motion.a
                  href="#"
                  className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-aero-blue hover:bg-aero-blue hover:text-white transition-all duration-200"
                  whileHover={{ scale: 1.1, rotate: -5 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <FiInstagram size={18} />
                </motion.a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar - REMOVED "MADE WITH EMERGENT" */}
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex flex-wrap items-center space-x-6 text-sm text-shadow-gray">
            <a href="#" className="hover:text-aero-blue transition-colors duration-200">Privacy Policy</a>
            <a href="#" className="hover:text-aero-blue transition-colors duration-200">Terms of Service</a>
            <a href="#" className="hover:text-aero-blue transition-colors duration-200">Cookies</a>
          </div>
          <p className="text-shadow-gray text-sm">
            © 2024 
            <Link 
              to="/helicopter-game" 
              className="text-aero-blue hover:text-cyan-400 transition-colors duration-200 mx-1 font-medium"
            >
              Blacksand Aero
            </Link>
            . All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;